import { useState, useEffect } from 'react';
import { useField } from 'formik';
import { CheckboxInput } from 'components/form/CheckboxInput';
import ServiceFeeTermsModal from './ServiceFeeTermsModal';

const FIELD_NAME = 'terms.bServiceFeeAcknowledgement';

/**
 * Shared "Service Fee Acknowledgement" checkbox + Review Document modal, used by the
 * business (V2/V3) verification Final Steps. Only rendered/required for the jhglobal brand —
 * auto-satisfies the field for other brands so it doesn't block their Continue button.
 */
export const ServiceFeeAcknowledgementInput = ({ isJhGlobal }: { isJhGlobal: boolean }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [{ value }, , { setValue }] = useField<boolean>(FIELD_NAME);

    useEffect(() => {
        if (!isJhGlobal && !value) setValue(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isJhGlobal]);

    if (!isJhGlobal) return null;

    return (
        <div className="FormBox">
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <div className="FormLabel">
                    <label>Service Fee Acknowledgement</label>
                </div>
                <button
                    type="button"
                    onClick={() => setIsModalOpen(true)}
                    style={{
                        background: 'none',
                        border: 'none',
                        padding: 0,
                        color: '#6366f1',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        fontSize: 13,
                    }}
                >
                    Review Document
                </button>
            </div>
            <div className="FormField ButtonCheckboxInput">
                <CheckboxInput
                    name={FIELD_NAME}
                    label={
                        <>
                            I understand and agree that each incoming wire received through 75
                            Pillars is subject to a Service Fee of twelve percent (12%) of the
                            transaction amount, calculated and applied as described in the Terms
                            &amp; Conditions.
                            <br />
                            <br />
                            E.g. If receiving a 10,000.00 USD wire to your 75 Pillars account, a
                            12% service fee plus an additional 0.4% OTC fee will be charged — for
                            this example this fee amounts to 1,235.66 USD. End user balance after
                            the fee will be 8,729.34 USD.
                        </>
                    }
                    checked={value}
                    disabled
                />
            </div>
            {!value && (
                <p style={{ color: '#888', fontSize: 12, margin: '4px 0 0' }}>
                    Please review and accept the document above to check this box.
                </p>
            )}
            {isModalOpen && (
                <ServiceFeeTermsModal
                    close={() => setIsModalOpen(false)}
                    onAccept={() => {
                        setValue(true);
                        setIsModalOpen(false);
                    }}
                />
            )}
        </div>
    );
};

export default ServiceFeeAcknowledgementInput;
